export const productionUrl = [
	"app.audiowizard.etl.fr",
];

const getEtlPP = (): string => {
	if (import.meta.env.VITE_APP_ENVIRONMENT === "development") return "http://localhost:80";

	return "https://etl.crescendo.audiowizard.fr";
}

const getAwPP = (): string => {
	if (import.meta.env.VITE_APP_ENVIRONMENT === "development") return "http://localhost:8000";

	return "https://api.audiowizard.fr/";
}

const getMercurePP = (): string => {
	if (import.meta.env.VITE_APP_ENVIRONMENT === "development") return "http://localhost/.well-known/mercure";

	return "https://etl.crescendo.audiowizard.fr/.well-known/mercure";
}

export const getApiUrl = (): { etlUrl: string; awUrl: string; mercureUrl: string } => {
	return {
		etlUrl: getEtlPP(),
		awUrl: getAwPP(),
		mercureUrl: getMercurePP()
	}
}
